/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as StripeImport } from './routes/stripe'
import { Route as LogoutImport } from './routes/logout'
import { Route as LoginImport } from './routes/login'
import { Route as AdminImport } from './routes/_admin'
import { Route as IndexImport } from './routes/index'
import { Route as AdminTeamsIndexImport } from './routes/_admin/teams/index'
import { Route as AdminSettingsIndexImport } from './routes/_admin/settings/index'
import { Route as AdminPaymentsIndexImport } from './routes/_admin/payments/index'
import { Route as AdminLearningBudgetsIndexImport } from './routes/_admin/learning-budgets/index'
import { Route as AdminLandingPagesIndexImport } from './routes/_admin/landing-pages/index'
import { Route as AdminEmployeesIndexImport } from './routes/_admin/employees/index'
import { Route as AdminCoursesIndexImport } from './routes/_admin/courses/index'
import { Route as AdminContractIndexImport } from './routes/_admin/contract/index'
import { Route as AdminCompaniesIndexImport } from './routes/_admin/companies/index'
import { Route as AdminApplicationsIndexImport } from './routes/_admin/applications/index'
import { Route as AdminTeamsTeamIdImport } from './routes/_admin/teams/$teamId'
import { Route as AdminLearningBudgetsTransactionsImport } from './routes/_admin/learning-budgets/transactions'
import { Route as AdminEmployeesEmployeeIdImport } from './routes/_admin/employees/$employeeId'
import { Route as AdminCoursesAddImport } from './routes/_admin/courses/add'
import { Route as AdminCoursesCourseIdEditImport } from './routes/_admin/courses/$courseId/edit'

// Create/Update Routes

const StripeRoute = StripeImport.update({
  path: '/stripe',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRoute = LogoutImport.update({
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AdminRoute = AdminImport.update({
  id: '/_admin',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AdminTeamsIndexRoute = AdminTeamsIndexImport.update({
  path: '/teams/',
  getParentRoute: () => AdminRoute,
} as any)

const AdminSettingsIndexRoute = AdminSettingsIndexImport.update({
  path: '/settings/',
  getParentRoute: () => AdminRoute,
} as any)

const AdminPaymentsIndexRoute = AdminPaymentsIndexImport.update({
  path: '/payments/',
  getParentRoute: () => AdminRoute,
} as any)

const AdminLearningBudgetsIndexRoute = AdminLearningBudgetsIndexImport.update({
  path: '/learning-budgets/',
  getParentRoute: () => AdminRoute,
} as any)

const AdminLandingPagesIndexRoute = AdminLandingPagesIndexImport.update({
  path: '/landing-pages/',
  getParentRoute: () => AdminRoute,
} as any)

const AdminEmployeesIndexRoute = AdminEmployeesIndexImport.update({
  path: '/employees/',
  getParentRoute: () => AdminRoute,
} as any)

const AdminCoursesIndexRoute = AdminCoursesIndexImport.update({
  path: '/courses/',
  getParentRoute: () => AdminRoute,
} as any)

const AdminContractIndexRoute = AdminContractIndexImport.update({
  path: '/contract/',
  getParentRoute: () => AdminRoute,
} as any)

const AdminCompaniesIndexRoute = AdminCompaniesIndexImport.update({
  path: '/companies/',
  getParentRoute: () => AdminRoute,
} as any)

const AdminApplicationsIndexRoute = AdminApplicationsIndexImport.update({
  path: '/applications/',
  getParentRoute: () => AdminRoute,
} as any)

const AdminTeamsTeamIdRoute = AdminTeamsTeamIdImport.update({
  path: '/teams/$teamId',
  getParentRoute: () => AdminRoute,
} as any)

const AdminLearningBudgetsTransactionsRoute =
  AdminLearningBudgetsTransactionsImport.update({
    path: '/learning-budgets/transactions',
    getParentRoute: () => AdminRoute,
  } as any)

const AdminEmployeesEmployeeIdRoute = AdminEmployeesEmployeeIdImport.update({
  path: '/employees/$employeeId',
  getParentRoute: () => AdminRoute,
} as any)

const AdminCoursesAddRoute = AdminCoursesAddImport.update({
  path: '/courses/add',
  getParentRoute: () => AdminRoute,
} as any)

const AdminCoursesCourseIdEditRoute = AdminCoursesCourseIdEditImport.update({
  path: '/courses/$courseId/edit',
  getParentRoute: () => AdminRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_admin': {
      preLoaderRoute: typeof AdminImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      preLoaderRoute: typeof LogoutImport
      parentRoute: typeof rootRoute
    }
    '/stripe': {
      preLoaderRoute: typeof StripeImport
      parentRoute: typeof rootRoute
    }
    '/_admin/courses/add': {
      preLoaderRoute: typeof AdminCoursesAddImport
      parentRoute: typeof AdminImport
    }
    '/_admin/employees/$employeeId': {
      preLoaderRoute: typeof AdminEmployeesEmployeeIdImport
      parentRoute: typeof AdminImport
    }
    '/_admin/learning-budgets/transactions': {
      preLoaderRoute: typeof AdminLearningBudgetsTransactionsImport
      parentRoute: typeof AdminImport
    }
    '/_admin/teams/$teamId': {
      preLoaderRoute: typeof AdminTeamsTeamIdImport
      parentRoute: typeof AdminImport
    }
    '/_admin/applications/': {
      preLoaderRoute: typeof AdminApplicationsIndexImport
      parentRoute: typeof AdminImport
    }
    '/_admin/companies/': {
      preLoaderRoute: typeof AdminCompaniesIndexImport
      parentRoute: typeof AdminImport
    }
    '/_admin/contract/': {
      preLoaderRoute: typeof AdminContractIndexImport
      parentRoute: typeof AdminImport
    }
    '/_admin/courses/': {
      preLoaderRoute: typeof AdminCoursesIndexImport
      parentRoute: typeof AdminImport
    }
    '/_admin/employees/': {
      preLoaderRoute: typeof AdminEmployeesIndexImport
      parentRoute: typeof AdminImport
    }
    '/_admin/landing-pages/': {
      preLoaderRoute: typeof AdminLandingPagesIndexImport
      parentRoute: typeof AdminImport
    }
    '/_admin/learning-budgets/': {
      preLoaderRoute: typeof AdminLearningBudgetsIndexImport
      parentRoute: typeof AdminImport
    }
    '/_admin/payments/': {
      preLoaderRoute: typeof AdminPaymentsIndexImport
      parentRoute: typeof AdminImport
    }
    '/_admin/settings/': {
      preLoaderRoute: typeof AdminSettingsIndexImport
      parentRoute: typeof AdminImport
    }
    '/_admin/teams/': {
      preLoaderRoute: typeof AdminTeamsIndexImport
      parentRoute: typeof AdminImport
    }
    '/_admin/courses/$courseId/edit': {
      preLoaderRoute: typeof AdminCoursesCourseIdEditImport
      parentRoute: typeof AdminImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  AdminRoute.addChildren([
    AdminCoursesAddRoute,
    AdminEmployeesEmployeeIdRoute,
    AdminLearningBudgetsTransactionsRoute,
    AdminTeamsTeamIdRoute,
    AdminApplicationsIndexRoute,
    AdminCompaniesIndexRoute,
    AdminContractIndexRoute,
    AdminCoursesIndexRoute,
    AdminEmployeesIndexRoute,
    AdminLandingPagesIndexRoute,
    AdminLearningBudgetsIndexRoute,
    AdminPaymentsIndexRoute,
    AdminSettingsIndexRoute,
    AdminTeamsIndexRoute,
    AdminCoursesCourseIdEditRoute,
  ]),
  LoginRoute,
  LogoutRoute,
  StripeRoute,
])

/* prettier-ignore-end */
